import PropTypes from 'prop-types';
import React from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import { cloneDeep, replaceValue } from '../../utils';
import Range from '../range';

const QuestionBlock = ({ item, handleAnswer }) => {
  const handleChange = answerObject => {
    let submitedAnswer = cloneDeep(item?.questions || []);
    submitedAnswer = submitedAnswer.map((question, index) => replaceValue(answerObject, question, index));
    handleAnswer(submitedAnswer);
  };
  return (
    <>
      <ListGroup variant="flush" key={item.id}>
        {item?.questions?.map(q => (
          <ListGroup.Item key={q.id}>{q.question}</ListGroup.Item>
        ))}
      </ListGroup>
      <Container>
        <Range id={1} questionId={item.id} className="range" handleChange={handleChange} />
      </Container>
      <hr />
    </>
  );
};

QuestionBlock.propTypes = {
  item: PropTypes.shape({
    questions: PropTypes.shape([]).isRequired,
    id: PropTypes.number.isRequired
  }).isRequired,
  handleAnswer: PropTypes.func.isRequired
};
export default QuestionBlock;
